<template>
  <div class="receiveRecord">
    <el-table :data="rightRequestData" border stripe v-loading="isLoading">
      <el-table-column prop="staff_name" label="经纪人"></el-table-column>
      <el-table-column prop="create_time" label="领取时间"></el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="tablePage">
      <el-pagination
        hide-on-single-page
        background
        @size-change="sizePage"
        :current-page.sync="search.page"
        :page-size="search.limit"
        :total="search.total"
        :page-sizes="[15, 20, 25]"
        layout="total, sizes, prev, pager, next"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      Type: Number,
      default: 0,
    },
    index: {
      Type: String,
      default: '',
    },
  },
  data() {
    return {
      isLoading: false,
      search: {
        total: 0,
        page: 1,
        limit: 15,
      },
      rightRequestData: [],
    }
  },
  watch: {
    'search.page'() {
      this.getImgList()
    },
    'search.limit'() {
      this.getImgList()
    },
    index(val) {
      if (val == 4) this.getImgList()
    },
  },
  methods: {
    sizePage(val) {
      this.search.limit = val
    },

    async getImgList() {
      this.isLoading = true
      let param = {
        ...this.search,
        id: this.id,
      }
      const date = await this.$api.receiveRecord(param)
      this.search.total = date.count
      this.rightRequestData = date.data
      this.isLoading = false
    },
  },
}
</script>

<style></style>
